export default "__VITE_ASSET__$LWU3jo7__"